import * as R from 'ramda';

const applySelectors = selectors => (...args) => R.mapObjIndexed(
  R.apply(R.__, args),
  selectors,
);

export default applySelectors;
